import dotProp from 'dot-prop-immutable';

import { REDUCE_PRODUCT, REDUCE_PRODUCTS } from '../../constants/actions/product';

const initialState = {
    entity: null,
    parameters: [],
    product: null,
    products: [],
};

function productReducer(state = initialState, action) {
    switch (action.type) {
        case REDUCE_PRODUCT:
            return dotProp.set(state, 'product', action.payload);
        case REDUCE_PRODUCTS:
            return dotProp.set(state, 'products', action.payload);
        default:
            return state;
    }
}

export default productReducer;
